<template>
    <canvas ref="linechart" width="1600" height="300" style="width:800;height:150"></canvas>
</template>

<script>
    export default {
        mounted() {
            this.$on('newplan', (elevation_data,distance) => {
                var step = distance / elevation_data.length;
                elevation_data = elevation_data.map(function(v, k) { return {x: k * step, y: v}; });
                this.chart = new Chart(this.$refs.linechart, {
                    type: 'line',
                    data: {
                        // labels: range(0,this.track_distance, this.track_distance / 100).map(x=> x + "km"),
                        datasets: [{
                            data: elevation_data,
                            borderColor: "#4D4D50",
                            fill: true,
                            // lineTension: 0,
                            backgroundColor: 'rgba(0,177,230, .1)',
                            pointBackgroundColor: '#4D4D50',
                            // pointBorderWidth: 0,
                            // radius: 0
                        }]
                    },
                    options: {
                        tooltips: {
                            enabled: false
                        },
                        // responsive: true,
                        title: {
                            display: false,
                        },
                        legend: {
                            display: false
                        },
                        scales: {
                            yAxes: [{
                                type: "linear",
                                ticks: {
                                    userCallback: function(tick) {
                                        if (tick.toString() % 10 == 0) {
                                            return tick.toString() + 'm';
                                        }
                                    },
                                },
                            }],
                            xAxes: [{
                                type: "linear",
                                ticks: {
                                    userCallback: function(tick) {
                                        if (tick.toString() % 1000 == 0) {
                                            return tick.toString()/1000 + 'km';
                                        }
                                    },
                                },
                            }],
                        }
                    }
                });
            });
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/Chart.vue